import React from "react";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";

export default function Locations() {
  const mainLocation = {
    name: "OGCS Private Limited (Head Office)",
    address: `No 03, C-6, 14, Rd Number 2
Sector 18, New Panvel, Dist: Raigad
Pin Code: 410206

Navi Mumbai, Panvel`,
    mobile: "+91 9967610135",
    email: "support@ogcs.co.in",
    type: "Head Office",
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-5xl mx-auto">
        
        {/* HEADER */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Office Location</h1>
          <p className="text-sm text-gray-500">
            Official registered office details
          </p>
        </div>

        {/* LOCATION CARD */}
        <div className="bg-white rounded-xl shadow border overflow-hidden">
          
          {/* TOP */}
          <div className="p-5 border-b flex items-center justify-between">
            <div>
              <span className="inline-flex items-center gap-2 text-xs font-semibold bg-blue-50 text-blue-700 px-3 py-1 rounded-full">
                <FiMapPin /> {mainLocation.type}
              </span>

              <h2 className="text-lg font-bold mt-2 text-gray-900">
                {mainLocation.name}
              </h2>
            </div>
          </div>

          {/* BODY */}
          <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-5">
            
            {/* ADDRESS */}
            <div className="bg-gray-50 p-4 rounded-lg border">
              <p className="text-xs text-gray-500">Address</p>
              <p className="text-sm text-gray-800 mt-1 whitespace-pre-line leading-relaxed">
                {mainLocation.address}
              </p>
            </div>

            {/* CONTACT */}
            <div className="bg-gray-50 p-4 rounded-lg border">
              <p className="text-xs text-gray-500">Contact</p>

              <div className="mt-3 space-y-2 text-sm">
                <div className="flex items-center gap-2 text-gray-800">
                  <FiPhone className="text-gray-500" />
                  <span>{mainLocation.mobile}</span>
                </div>

                <div className="flex items-center gap-2 text-gray-800">
                  <FiMail className="text-gray-500" />
                  <span className="break-all">{mainLocation.email}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}